import {IService} from "@/model/Service/Service"
import {IAccomodationService} from "@/model/Service/AccomodationService"
import ServiceFamily, {IServiceFamily} from "@/model/ServiceFamily/ServiceFamily"
import hasAccomodations, {IHasAccomodations} from "@/model/mixins/Accomodation/hasAccomodations"


class AccomodationServiceFamilyBase extends ServiceFamily {

    constructor(id: string) {
        super(id)
    }
    
    public isIncluded(): boolean {
        return !!this.getServices().find((service: IService) => {
            const accService = service as IAccomodationService
            return accService.getIncluded()
        })
    }
    public isSelected(): boolean {
        return !!this.getServices().find((service: IService) => {
            const accService = service as IAccomodationService
            return accService.getQuantitySelected() > 0
        })
    }

}

export interface IAccomodationServiceFamily extends AccomodationServiceFamilyBase, IServiceFamily, IHasAccomodations {

}

const AccomodationServiceFamily: Constructor<IAccomodationServiceFamily> = hasAccomodations(AccomodationServiceFamilyBase)

export default AccomodationServiceFamily